/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ArtistImageDto } from '../models';
/**
 * ArtistImagesApi - axios parameter creator
 */
export const ArtistImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistIdGet: async (artistId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistImagesArtistIdGet', 'artistId', artistId)
            const localVarPath = `/api/ArtistImages/{artistId}`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} artistId 
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistIdImageIdGet: async (artistId: string, imageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistImagesArtistIdImageIdGet', 'artistId', artistId)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('apiArtistImagesArtistIdImageIdGet', 'imageId', imageId)
            const localVarPath = `/api/ArtistImages/{artistId}/{imageId}`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} artistImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistImageIdDelete: async (artistImageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistImageId' is not null or undefined
            assertParamExists('apiArtistImagesArtistImageIdDelete', 'artistImageId', artistImageId)
            const localVarPath = `/api/ArtistImages/{artistImageId}`
                .replace(`{${"artistImageId"}}`, encodeURIComponent(String(artistImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} artistImageId 
         * @param {ArtistImageDto} [artistImageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistImageIdPut: async (artistImageId: string, artistImageDto?: ArtistImageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistImageId' is not null or undefined
            assertParamExists('apiArtistImagesArtistImageIdPut', 'artistImageId', artistImageId)
            const localVarPath = `/api/ArtistImages/{artistImageId}`
                .replace(`{${"artistImageId"}}`, encodeURIComponent(String(artistImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artistImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistImages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtistImagesApi - functional programming interface
 */
export const ArtistImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtistImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistImagesArtistIdGet(artistId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistImagesArtistIdGet(artistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistImagesApi.apiArtistImagesArtistIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} artistId 
         * @param {string} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistImagesArtistIdImageIdGet(artistId: string, imageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistImagesArtistIdImageIdGet(artistId, imageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistImagesApi.apiArtistImagesArtistIdImageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} artistImageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistImagesArtistImageIdDelete(artistImageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistImagesArtistImageIdDelete(artistImageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistImagesApi.apiArtistImagesArtistImageIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} artistImageId 
         * @param {ArtistImageDto} [artistImageDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistImagesArtistImageIdPut(artistImageId: string, artistImageDto?: ArtistImageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistImagesArtistImageIdPut(artistImageId, artistImageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistImagesApi.apiArtistImagesArtistImageIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistImagesPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistImagesPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistImagesApi.apiArtistImagesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtistImagesApi - factory interface
 */
export const ArtistImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtistImagesApiFp(configuration)
    return {
        /**
         * 
         * @param {ArtistImagesApiApiArtistImagesArtistIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistIdGet(requestParameters: ArtistImagesApiApiArtistImagesArtistIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistImagesArtistIdGet(requestParameters.artistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistImagesApiApiArtistImagesArtistIdImageIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistIdImageIdGet(requestParameters: ArtistImagesApiApiArtistImagesArtistIdImageIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistImagesArtistIdImageIdGet(requestParameters.artistId, requestParameters.imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistImagesApiApiArtistImagesArtistImageIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistImageIdDelete(requestParameters: ArtistImagesApiApiArtistImagesArtistImageIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistImagesArtistImageIdDelete(requestParameters.artistImageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistImagesApiApiArtistImagesArtistImageIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesArtistImageIdPut(requestParameters: ArtistImagesApiApiArtistImagesArtistImageIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistImagesArtistImageIdPut(requestParameters.artistImageId, requestParameters.artistImageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistImagesApiApiArtistImagesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistImagesPost(requestParameters: ArtistImagesApiApiArtistImagesPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistImagesPost(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArtistImagesArtistIdGet operation in ArtistImagesApi.
 */
export interface ArtistImagesApiApiArtistImagesArtistIdGetRequest {
    readonly artistId: string
}

/**
 * Request parameters for apiArtistImagesArtistIdImageIdGet operation in ArtistImagesApi.
 */
export interface ArtistImagesApiApiArtistImagesArtistIdImageIdGetRequest {
    readonly artistId: string

    readonly imageId: string
}

/**
 * Request parameters for apiArtistImagesArtistImageIdDelete operation in ArtistImagesApi.
 */
export interface ArtistImagesApiApiArtistImagesArtistImageIdDeleteRequest {
    readonly artistImageId: string
}

/**
 * Request parameters for apiArtistImagesArtistImageIdPut operation in ArtistImagesApi.
 */
export interface ArtistImagesApiApiArtistImagesArtistImageIdPutRequest {
    readonly artistImageId: string

    readonly artistImageDto?: ArtistImageDto
}

/**
 * Request parameters for apiArtistImagesPost operation in ArtistImagesApi.
 */
export interface ArtistImagesApiApiArtistImagesPostRequest {
    readonly file?: File
}

/**
 * ArtistImagesApi - object-oriented interface
 */
export class ArtistImagesApi extends BaseAPI {
    /**
     * 
     * @param {ArtistImagesApiApiArtistImagesArtistIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistImagesArtistIdGet(requestParameters: ArtistImagesApiApiArtistImagesArtistIdGetRequest, options?: RawAxiosRequestConfig) {
        return ArtistImagesApiFp(this.configuration).apiArtistImagesArtistIdGet(requestParameters.artistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistImagesApiApiArtistImagesArtistIdImageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistImagesArtistIdImageIdGet(requestParameters: ArtistImagesApiApiArtistImagesArtistIdImageIdGetRequest, options?: RawAxiosRequestConfig) {
        return ArtistImagesApiFp(this.configuration).apiArtistImagesArtistIdImageIdGet(requestParameters.artistId, requestParameters.imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistImagesApiApiArtistImagesArtistImageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistImagesArtistImageIdDelete(requestParameters: ArtistImagesApiApiArtistImagesArtistImageIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ArtistImagesApiFp(this.configuration).apiArtistImagesArtistImageIdDelete(requestParameters.artistImageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistImagesApiApiArtistImagesArtistImageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistImagesArtistImageIdPut(requestParameters: ArtistImagesApiApiArtistImagesArtistImageIdPutRequest, options?: RawAxiosRequestConfig) {
        return ArtistImagesApiFp(this.configuration).apiArtistImagesArtistImageIdPut(requestParameters.artistImageId, requestParameters.artistImageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistImagesApiApiArtistImagesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistImagesPost(requestParameters: ArtistImagesApiApiArtistImagesPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistImagesApiFp(this.configuration).apiArtistImagesPost(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}

